import { render, staticRenderFns } from "./ThirdPartyAccess.vue?vue&type=template&id=5db3f6e8&"
import script from "./ThirdPartyAccess.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db3f6e8')) {
      api.createRecord('5db3f6e8', component.options)
    } else {
      api.reload('5db3f6e8', component.options)
    }
    module.hot.accept("./ThirdPartyAccess.vue?vue&type=template&id=5db3f6e8&", function () {
      api.rerender('5db3f6e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Settings/ThirdPartyAccess.vue"
export default component.exports